import ModelService from "./abstract/ModelService";
import Contract from "../models/Contract";

export default class ContractService extends ModelService {
  constructor() {
    super('/contracts', Contract);
  }

  createSignOff(modelId, model) {
    return new Promise((resolve, reject) => {
      this.get(env.API_URL + this.modelPath + '/' + modelId + '/sign-off', this.modelName ? { [this.modelName]: model } : model).then(data => {
        resolve(data)
      }).catch((e) => reject(e.response));
    });
  }

  signOff(modelId, model) {
    return new Promise((resolve, reject) => {
      this.put(env.API_URL + this.modelPath + '/' + modelId + '/sign-off', this.modelName ? { [this.modelName]: model } : model).then(data => {

        let item = new this.Model(data);
        resolve(item);
      }).catch((e) => reject(e.response));
    });
  }

  editOrderNumber(modelId, newOrderNumber) {
    return new Promise((resolve, reject) => {
      this.put(env.API_URL + this.modelPath + '/' + modelId + '/order-number', { order_number: newOrderNumber }).then(data => {
        let item = new this.Model(data);
        resolve(item);
      }).catch((e) => reject(e.response));
    });
  }
}
